import { SEVERITY_BADGE_MAP, SEVERITY_MAP } from '@/constants/common'

export const IMPACT = SEVERITY_MAP
export const EFFORT = SEVERITY_MAP
export const REACH = SEVERITY_MAP
export const IMPACT_BADGE_MAP = SEVERITY_BADGE_MAP
export const DEFAULT_IMPACT = SEVERITY_MAP.low.id
export const DEFAULT_EFFORT = SEVERITY_MAP.low.id
export const DEFAULT_REACH = SEVERITY_MAP.low.id
export const IDEA_ROW = 'IdeaRow'

export const IDEA_EVENT_TYPE = {
  COMMENT: 'comment',
  CREATED: 'created'
}
